import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { loadingBarMiddleware } from 'react-redux-loading-bar'
import thunk from 'redux-thunk';

import userReducer from './reducers/userReducer';
import permistionsReducer from './reducers/permistionsReducer';
import uiReducer from './reducers/uiReducer';
import usersReducer from './reducers/usersReducer';
import categoriesReducer from './reducers/categoriesReducer';
import settingsReducer from './reducers/settingsReducer';
import imageReducer from './reducers/imageReducer';
import getImageReducer from './reducers/getImageReducer';
import filterUseReducer from './reducers/filterUseReducer';
import postsReducer from './reducers/postsReducer';

const initialState = {};

const middleware = [thunk];

const reducers = combineReducers({
    user : userReducer,
    users: usersReducer,
    permistions: permistionsReducer,
    filterUserData: filterUseReducer,
    UI : uiReducer,
    categories : categoriesReducer,
    settings: settingsReducer,
    image_forders: imageReducer,
    get_image: getImageReducer,
    posts: postsReducer,
})

const store = createStore(
    reducers, 
    initialState, 
    compose(
        applyMiddleware(
            ...middleware,
            loadingBarMiddleware()
        ),
    window.__REDUX_DEVTOOLS_EXTENSION__
? window.__REDUX_DEVTOOLS_EXTENSION__()
: f => f));

export default store;